import React from "react";
import { Alert, Button, VStack } from "@chakra-ui/react";

interface ErrorAlertProps {
  isError: boolean;
  title?: string;
  message?: string;
  onRetry?: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  isError,
  title = "Error occurred",
  message = "Something went wrong. Please try again.",
  onRetry,
}) => {
  if (!isError) return null;

  return (
    <Alert.Root status="error">
      <Alert.Indicator />
      <Alert.Content>
        <VStack align="start" gap={2} flex={1}>
          <Alert.Title>{title}</Alert.Title>
          <Alert.Description>{message}</Alert.Description>
          {onRetry && (
            <Button size="sm" colorPalette="red" variant="outline" onClick={onRetry}>
              Retry
            </Button>
          )}
        </VStack>
      </Alert.Content>
    </Alert.Root>
  );
};

export default ErrorAlert;
